import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { appRoute } from 'app/railways/router/routes';

import { DetailsRoute } from '../features/details-route/details-route';

export const DetailsRoutePage = observer(() => {
  const { routeId } = useTypedParams(appRoute.ROUTES.DETAILS);

  const pageNotify = useNotifyFactory();

  if (!routeId) return null;

  return (
    <NotificationsProvider value={pageNotify}>
      <AppPage perm="PERM_ROUTE_READ">
        <DetailsRoute routeId={routeId} />
      </AppPage>
    </NotificationsProvider>
  );
});
